








import Vue from "vue";
import { Component } from "vue-property-decorator";
import ApiFactory from "../../api/ApiFactory";
import { ProductProviderDto } from "@/api/ClientPortalApiClient";

@Component({})
export default class CbxProductProvider extends Vue {
  private types: ProductProviderDto[] | null = [];
  private selectedType = new ProductProviderDto();
  public created() {
    this.getAvailableTypes();
  }

  public setSelected(type: ProductProviderDto | undefined) {
    if (type) {
      this.selectedType = type;
    }
  }

  public setSelectedName(name: string) {
    if (this.types) {
      this.types.forEach(element => {
        if (element.name === name) {
          this.selectedType = element;
          return;
        }
      });
    }
  }

  public typeSelected(type: ProductProviderDto) {
    this.$emit("productProviderSelected", type);
  }

  private getAvailableTypes() {
    const api = ApiFactory.CreateDataClient();
    api
      .productProvider_IndexAll()
      .then(result => {
        if (result) {
          this.types = result;
        } else {
          this.types = [];
        }
      })
      .catch(error => {
        console.log(error);
        this.types = [];
      });
  }
}
